export default "__VITE_ASSET__BDvGi5TD__"